import { Typography, useTheme } from '@mui/material'
import type { TypographyProps } from '@mui/material'

interface TitleProps extends TypographyProps {
  children: React.ReactNode
}

const Title = ({ fontSize = '1.25rem', color, ...props }: TitleProps) => {
  const theme = useTheme()
  return (
    <Typography
      fontSize={fontSize}
      lineHeight="normal"
      color={color ?? theme.palette.text.primary}
      {...props}
    >
      {props.children}
    </Typography>
  )
}

export default Title
